export default {
    apiKey       : "AIzaSyBR1sLlDhvLM4W39D34WyJt2IS9ADEiXtE",
    projectId    : "toolridescom",
    databaseURL  : "https://toolridescom.firebaseio.com",
    authDomain   : "toolridescom.firebaseapp.com",
    storageBucket: 'gs://toolridescom.appspot.com',
};